import * as React from "react"
import PropTypes from "prop-types"
import * as styles from "./ProjectPageLayout.module.css"

const ProjectPageLayout = ({ heading, subheading, children }) => {
  return (
      <div className={styles.projectPageLayout}>
        <h1 className={styles.heading}>{heading}</h1>
        {subheading && <p className={styles.subheading}>{subheading}</p>}
        {children}
      </div>
  )
}

ProjectPageLayout.propTypes = {
  heading: PropTypes.string.isRequired,
  subheading: PropTypes.string,
  children: PropTypes.node.isRequired,
}

export default ProjectPageLayout
